<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="商家名">
          <el-input placeholder="请输入商家名" v-model="formInline.shop_name"></el-input>
        </el-form-item>
        <el-form-item label="使用状态">
          <el-select v-model="formInline.is_use" placeholder="请选择使用状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="未使用" value="0"></el-option>
            <el-option label="已使用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker 
              v-model="formInline.create_time" 
              type="daterange" 
              value-format="yyyy-MM-dd" 
              range-separator="至" 
              start-placeholder="开始日期" 
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
        <el-form-item>
        <el-dropdown @command="handleExportCommand" split-button type="success" size="small">
            导出
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="excel_image">Excel带图片(适合打印)</el-dropdown-item>
              <el-dropdown-item command="csv_progress" divided>CSV分批导出(仅数据)</el-dropdown-item>
               <el-dropdown-item command="excel_zip">Excel分批ZIP(适合3000+条)</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
      </el-form>
    </div>

    <!-- 导出进度对话框 -->
    <el-dialog
      title="导出进度"
      :visible.sync="exportProgressVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="export-progress-content">
        <div class="progress-info">
          <span>正在导出数据...</span>
          <span>{{ exportProgress.percentage }}%</span>
        </div>
        <el-progress 
          :percentage="exportProgress.percentage" 
          :status="exportProgress.status"
          :stroke-width="15"
          :text-inside="true"
        ></el-progress>
        <div class="progress-detail" v-if="exportProgress.total > 0">
          <p>已导出: {{ exportProgress.exported }} / {{ exportProgress.total }} 条</p>
          <p v-if="exportProgress.currentPage">当前页: {{ exportProgress.currentPage }}/{{ exportProgress.totalPages }}</p>
          <p v-if="exportProgress.speed">速度: {{ exportProgress.speed }} 条/秒</p>
          <p v-if="exportProgress.estimatedTime">预计剩余: {{ exportProgress.estimatedTime }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button 
          type="danger" 
          @click="cancelExport" 
          :disabled="exportProgress.status === 'success'"
          :loading="exportProgress.cancelling"
        >取消导出</el-button>
        <el-button 
          type="primary" 
          @click="exportProgressVisible = false" 
          :disabled="exportProgress.status !== 'success' && exportProgress.status !== 'exception'"
        >关闭</el-button>
      </span>
    </el-dialog>

    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
      >添加入驻码</el-button>
      <el-button size="small" icon="el-icon-printer" type="warning" @click="handleBatchPrint">批量打印</el-button>
      <el-button size="small" type="danger" icon="el-icon-delete" @click="handleBatchDelete">批量删除</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table 
            size="small" 
            :data="tableData" 
            border 
            style="width: 100%" 
            v-loading="loading" 
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="merchant_onboarding_id" label="id" width="80"></el-table-column>
            <el-table-column label="入驻码" width="100">
              <template slot-scope="scope">
                <img 
                  v-if="scope.row.image" 
                  :src="scope.row.image.file_path || scope.row.image" 
                  width="60" 
                  height="60" 
                  style="object-fit: cover; border-radius: 4px;" 
                />
                <span v-else>无图片</span>
              </template>
            </el-table-column>
            <el-table-column label="是否使用" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.is_use == 1 ? 'success' : 'info'" size="small">
                  {{ scope.row.is_use == 1 ? '已使用' : '未使用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="商家名" min-width="150">
              <template slot-scope="scope">
                {{ scope.row.supply && scope.row.supply.name ? scope.row.supply.name : '--' }}
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="160"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="downloadClick(scope.row)" type="text" size="small">
                  <i class="el-icon-download"></i> 下载
                </el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small" style="color: #f56c6c;">
                  <i class="el-icon-delete"></i> 删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :merchant_onboarding_id="merchant_onboarding_id" v-if="open_edit" @close="closeEdit"></Edit>
  </div>
</template>

<script>
import Merchant_onboardingApi from '@/api/merchant_onboarding.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';
import qs from 'qs';

export default {
  components: {
    Add,
    Edit,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: "",
        shop_name: "",
        is_use: "",
        create_time: ""
      },
      open_add: false,
      open_edit: false,
      merchant_onboarding_id: "",
      selectedRows: [], // 用于存储选择的入驻码
      
      // 导出进度相关
      exportProgressVisible: false,
      exportProgress: {
        percentage: 0,
        status: 'normal', // normal, success, exception
        total: 0,
        exported: 0,
        currentPage: 0,
        totalPages: 0,
        speed: 0,
        estimatedTime: '',
        cancelling: false
      },
      exportTimer: null,
      exportCancelFlag: false,
      exportStartTime: null,
      exportType: 'csv_progress' // 默认导出类型
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;

      // 处理创建时间参数
      if (self.formInline.create_time && self.formInline.create_time.length === 2) {
        Params.create_time_start = self.formInline.create_time[0];
        Params.create_time_end = self.formInline.create_time[1];
      }

      self.loading = true;
      Merchant_onboardingApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
          this.$message.error('获取列表失败');
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.merchant_onboarding_id = row.merchant_onboarding_id;
      this.open_edit = true;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          Merchant_onboardingApi.del(
            {
              merchant_onboarding_id: row.merchant_onboarding_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.getTableList();
              } else {
                self.$message.error('删除失败');
              }
            })
            .catch(error => {
              self.$message.error('删除失败');
            });
        })
        .catch(() => {});
    },

    /*下载入驻码*/
    downloadClick(row) {
      let imgUrl = row.image;
      if (typeof imgUrl === 'object' && imgUrl.file_path) {
        imgUrl = imgUrl.file_path;
      }
      if (imgUrl) {
        this.performDownload(imgUrl, row);
      } else {
        this.$message.error('入驻码图片不存在，无法下载');
      }
    },

    /*执行下载操作*/
    performDownload(imgUrl, row) {
      const link = document.createElement('a');
      link.href = imgUrl;
      link.download = `入驻码_${row.merchant_onboarding_id}.png`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 更新下载状态
      if (row.is_download !== 1) {
        Merchant_onboardingApi.updatedownload({
          merchant_onboarding_id: row.merchant_onboarding_id,
          is_download: 1
        }).then(data => {
          row.is_download = 1;
        });
      }

      this.$message.success('下载已开始');
    },

    /*处理选择变化*/
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    /*批量打印功能*/
    handleBatchPrint() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一个入驻码');
        return;
      }

      const validRows = this.selectedRows.filter(row => {
        return row.image;
      });

      if (validRows.length === 0) {
        this.$message.warning('所选入驻码中没有图片，无法打印');
        return;
      }

      let printContent = '<div class="print-qrcode-container">';

      validRows.forEach(row => {
        let imgUrl = row.image;
        if (typeof imgUrl === 'object' && imgUrl.file_path) {
          imgUrl = imgUrl.file_path;
        }

        printContent += `
          <div class="print-qrcode-item">
            <img src="${imgUrl}" alt="入驻码" class="print-qrcode-img">
            <p class="print-qrcode-text">入驻码</p>
            <p class="print-qrcode-id">ID: ${row.merchant_onboarding_id}</p>
            ${row.supply && row.supply.name ? `<p class="print-qrcode-shop">商家: ${row.supply.name}</p>` : ''}
          </div>
        `;
      });

      printContent += '</div>';

      const printWindow = window.open("");
      printWindow.document.write(`
        <html>
          <head>
            <style>
              body { font-family: Arial, sans-serif; margin: 0px; padding: 20px; }
              .print-qrcode-container { display: flex; flex-wrap: wrap; gap: 20px; justify-content: center; }
              .print-qrcode-item { text-align: center; padding: 20px; border: 1px solid #eee; border-radius: 8px; width: 200px; margin-bottom: 20px; }
              .print-qrcode-img { width: 150px; height: 150px; margin-bottom: 10px; object-fit: cover; }
              .print-qrcode-text { margin: 0 0 5px 0; font-size: 14px; color: #333; font-weight: bold; }
              .print-qrcode-id { margin: 0 0 5px 0; font-size: 12px; color: #666; }
              .print-qrcode-shop { margin: 0; font-size: 12px; color: #999; }
            </style>
          </head>
          <body>${printContent}</body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    },

 // 在methods中添加
/*ZIP分批导出*/
exportExcelZip() {
  const params = Object.assign({}, this.formInline);
  
  // 处理时间参数
  if (this.formInline.create_time && this.formInline.create_time.length === 2) {
    params.create_time_start = this.formInline.create_time[0];
    params.create_time_end = this.formInline.create_time[1];
  }
  
  this.$confirm(`本次将导出 ${this.totalDataNumber} 条数据，系统将分批生成Excel文件并打包成ZIP下载，是否继续？`, '确认导出', {
    confirmButtonText: '开始导出',
    cancelButtonText: '取消',
    type: 'info'
  }).then(() => {
    const loading = this.$loading({
      lock: true,
      text: '正在生成ZIP文件，请稍候...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });

      // 删除分页参数
      delete params.page;
      delete params.list_rows;
      
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let exportUrl = baseUrl + '/index.php/shop/plus.merchant_onboarding.index/batchExportZip?' + qs.stringify(params);
          loading.close();
      window.open(exportUrl, '_blank');
   
    
    // Merchant_onboardingApi.exportExcelZip(params)
    //   .then(res => {
    //     loading.close();
    //     // 下载文件
    //     const blob = new Blob([res], { type: 'application/zip' });
    //     const link = document.createElement('a');
    //     link.href = URL.createObjectURL(blob);
    //     link.download = `入驻码导出_${this.formatDate(new Date())}_${this.totalDataNumber}条.zip`;
    //     link.click();
    //     URL.revokeObjectURL(link.href);
    //     this.$message.success('导出成功，请解压ZIP文件查看');
    //   })
    //   .catch(error => {
    //     loading.close();
    //     this.$message.error('导出失败：' + error.message);
    //   });
  }).catch(() => {});
},

// 修改handleExportCommand
handleExportCommand(command) {
  this.exportType = command;
  
  if (command === 'excel_image') {
    // Excel带图片导出
    this.exportExcelWithImage();
  } else if (command === 'excel_zip') {
    // ZIP分批导出
    this.exportExcelZip();
  } else if (command === 'csv_progress') {
    // CSV分批导出
    this.startProgressExport();
  }
},
    /*Excel带图片导出*/
exportExcelWithImage() {
  const params = Object.assign({}, this.formInline);
  
  // 处理时间参数
  if (this.formInline.create_time && this.formInline.create_time.length === 2) {
    params.create_time_start = this.formInline.create_time[0];
    params.create_time_end = this.formInline.create_time[1];
  }
  
  // 设置导出参数
  params.export_type = 'excel_image';
  params.include_image = 1;  // 包含图片
  
  // 检查数据量，给出提示
  if (this.totalDataNumber > 1000) {
    this.$confirm(`当前数据量较大(${this.totalDataNumber}条)，Excel带图片导出可能较慢，是否继续？`, '提示', {
      confirmButtonText: '继续导出',
      cancelButtonText: '取消'
    }).then(() => {
      this.doExport(params);
    }).catch(() => {});
  } else {
    this.doExport(params);
  }
},

  /*执行导出请求*/
  doExport(params) {

 // 删除分页参数
      delete params.page;
      delete params.list_rows;
      
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let exportUrl = baseUrl + '/index.php/shop/plus.merchant_onboarding.index/exportExcel?' + qs.stringify(params);
      
      window.open(exportUrl, '_blank');
      this.$message.success('导出请求已发送，请稍候...');


    return;


    // 删除分页参数
    delete params.page;
    delete params.list_rows;
    
    // 显示加载提示
    const loading = this.$loading({
      lock: true,
      text: '正在生成Excel文件，请稍候...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    
    // 调用导出接口
    Merchant_onboardingApi.exportExcel(params)
      .then(res => {
        loading.close();
        // 下载文件
        const blob = new Blob([res], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `入驻码打印_${this.formatDate(new Date())}_${this.totalDataNumber}条.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);
        this.$message.success('导出成功，请打印Excel文件');
      })
      .catch(error => {
        loading.close();
        this.$message.error('导出失败：' + error.message);
      });
  },

    /*普通导出（无进度）*/
    simpleExport(exportType) {
      const params = Object.assign({}, this.formInline);
      
      // 根据导出类型设置参数
      params.batch_export = 1;
      params.export_type = exportType;
      
      if (exportType === 'excel_image') {
        params.include_image = 1;
        params.page_size = 500;
        // 检查数据量
        if (this.totalDataNumber > 1000) {
          this.$confirm(`当前数据量较大(${this.totalDataNumber}条)，Excel带图片导出可能较慢或失败，建议使用CSV分批导出。是否继续？`, '提示', {
            confirmButtonText: '继续导出',
            cancelButtonText: '使用CSV'
          }).then(() => {
            this.doExport(params);
          }).catch(() => {
            this.startProgressExport();
          });
          return;
        }
      } else {
        params.include_image = 0;
        params.page_size = 2000;
      }
      
      this.doExport(params);
    },

    /*执行导出请求*/
    doExport(params) {
      // 删除分页参数
      delete params.page;
      delete params.list_rows;
      
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let exportUrl = baseUrl + '/index.php/shop/plus.merchant_onboarding.index/export?' + qs.stringify(params);
      
      window.open(exportUrl, '_blank');
      this.$message.success('导出请求已发送，请稍候...');
    },

    /*开始进度导出（分批导出）*/
   /*开始进度导出（分批导出）*/
  startProgressExport() {
    // 生成唯一的export_id
    const exportId = 'export_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    
    // 重置进度
    this.exportProgress = {
      percentage: 0,
      status: 'normal',
      total: this.totalDataNumber,
      exported: 0,
      currentPage: 0,
      totalPages: Math.ceil(this.totalDataNumber / 70),
      speed: 0,
      estimatedTime: '',
      cancelling: false,
      exportId: exportId  // 存储export_id
    };
    
    this.exportProgressVisible = true;
    this.exportCancelFlag = false;
    this.exportStartTime = Date.now();
    this.exportData = [];  // 存储所有导出的数据
    
    // 开始第一页的导出
    this.fetchExportPage(1);
  },
   /*获取导出数据页*/
fetchExportPage(page) {
  if (this.exportCancelFlag) {
    this.exportProgress.status = 'exception';
    this.$message.warning('导出已取消');
    return;
  }

  // 构建请求参数
  const params = Object.assign({}, this.formInline);
  params.page = page;
  params.page_size = 70;
  params.export_id = this.exportProgress.exportId;  // 传递export_id

  // 处理时间参数
  if (this.formInline.create_time && this.formInline.create_time.length === 2) {
    params.create_time_start = this.formInline.create_time[0];
    params.create_time_end = this.formInline.create_time[1];
  }

  this.exportProgress.currentPage = page;

  // 调用API获取数据
  Merchant_onboardingApi.getExportPage(params)
    .then(res => {
      if (res.code === 1) {
        // 存储数据到本地
        if (res.data.list) {
          this.exportData = this.exportData.concat(res.data.list);
        }
        
        this.exportProgress.exported += (res.data.count || 0);
        this.exportProgress.percentage = Math.min(
          Math.round((this.exportProgress.exported / this.exportProgress.total) * 100),
          100
        );
        
        // 计算速度
        const elapsedSeconds = (Date.now() - this.exportStartTime) / 1000;
        this.exportProgress.speed = elapsedSeconds > 0 ? 
          Math.round(this.exportProgress.exported / elapsedSeconds) : 0;
        
        // 如果还有下一页，继续获取
        if (res.data.has_more && !this.exportCancelFlag) {
          setTimeout(() => {
            this.fetchExportPage(page + 1);
          }, 100);
        } else {
          // 所有页面获取完成，直接生成CSV（不需要后端再合并）
          this.generateCSVLocally();
        }
      } else {
        this.exportProgress.status = 'exception';
        this.$message.error(res.msg || '导出失败');
      }
    })
    .catch(error => {
      this.exportProgress.status = 'exception';
      this.$message.error('导出请求失败：' + error.message);
    });
},
    /*完成导出*/
    finishExport() {
      this.exportProgress.percentage = 100;
      this.exportProgress.status = 'success';
      
      // 生成并下载最终文件
      this.downloadFinalFile();
      
      this.$message.success('导出完成，开始下载文件');
    },

    /*下载最终文件*/
    downloadFinalFile() {
      const params = Object.assign({}, this.formInline);
      params.download_final = 1;
      params.export_type = 'csv_progress';
      
      // 处理时间参数
      if (this.formInline.create_time && this.formInline.create_time.length === 2) {
        params.create_time_start = this.formInline.create_time[0];
        params.create_time_end = this.formInline.create_time[1];
      }
      
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let downloadUrl = baseUrl + '/index.php/shop/plus.merchant_onboarding.index/export?' + qs.stringify(params);
      
      // 创建一个隐藏的iframe来下载，避免页面刷新
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = downloadUrl;
      document.body.appendChild(iframe);
      
      // 5秒后移除iframe
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 5000);
    },
    /*本地生成CSV文件*/
generateCSVLocally() {
  if (this.exportData.length === 0) {
    this.$message.warning('没有数据可导出');
    return;
  }
  
  // 定义CSV列头
  const headers = ['入驻码ID', '图片链接', '是否使用', '供应商名称', '创建时间', '店铺名称'];
  
  // 构建CSV内容
  let csvContent = "\uFEFF" + headers.join(',') + '\n';
  
  this.exportData.forEach(row => {
    // 处理图片链接
    let imageUrl = '';
    if (row.image) {
      if (typeof row.image === 'object' && row.image.file_path) {
        imageUrl = row.image.file_path;
      } else {
        imageUrl = row.image;
      }
    }
    
    // 处理特殊字符
    const escapeField = (field) => {
      if (field === null || field === undefined) return '';
      field = String(field);
      if (field.includes(',') || field.includes('"') || field.includes('\n')) {
        return '"' + field.replace(/"/g, '""') + '"';
      }
      return field;
    };
    
    const line = [
      escapeField(row.merchant_onboarding_id || ''),
      escapeField(imageUrl),
      escapeField(row.is_use == 1 ? '已使用' : '未使用'),
      escapeField(row.supply && row.supply.name ? row.supply.name : ''),
      escapeField(row.create_time || ''),
      escapeField(row.shop_name || '')
    ].join(',');
    
    csvContent += line + '\n';
  });
  
  // 创建Blob并下载
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = `入驻码导出_${this.formatDate(new Date())}_${this.exportData.length}条.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  
  this.exportProgress.status = 'success';
  this.exportProgress.percentage = 100;
  this.$message.success('导出完成');
},

/*格式化日期*/
formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  const second = String(date.getSeconds()).padStart(2, '0');
  return `${year}${month}${day}_${hour}${minute}${second}`;
},
    /*取消导出*/

cancelExport() {
  this.$confirm('确定要取消导出吗？已导出的数据将不会保存。', '取消导出', {
    confirmButtonText: '确定取消',
    cancelButtonText: '继续导出',
    type: 'warning'
  }).then(() => {
    this.exportCancelFlag = true;
    this.exportProgress.cancelling = true;
    this.exportProgress.status = 'exception';
    this.$message.warning('导出已取消');
    this.exportProgress.cancelling = false;
  }).catch(() => {});
},

    /*格式化时间*/
    formatTime(seconds) {
      if (seconds < 60) {
        return Math.round(seconds) + '秒';
      } else if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60);
        const secs = Math.round(seconds % 60);
        return minutes + '分' + secs + '秒';
      } else {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        return hours + '小时' + minutes + '分';
      }
    },

    /*批量删除功能*/
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请至少选择一个入驻码进行删除');
        return;
      }
      
      const selectedIds = this.selectedRows.map(row => row.merchant_onboarding_id);
      const count = selectedIds.length;
      
      this.$confirm(`确定要删除选中的 ${count} 条入驻码记录吗？此操作不可撤销！`, '批量删除确认', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '删除中...';
            
            Merchant_onboardingApi.batchDel({
              merchant_onboarding_ids: selectedIds
            }, true)
              .then(response => {
                instance.confirmButtonLoading = false;
                if (response.code == 1) {
                  this.$message({
                    message: `成功删除 ${count} 条记录`,
                    type: 'success'
                  });
                  done();
                  this.getTableList();
                  this.selectedRows = [];
                } else {
                  this.$message.error(response.message || '删除失败');
                  done();
                }
              })
              .catch(error => {
                instance.confirmButtonLoading = false;
                this.$message.error('删除请求失败，请稍后重试');
                done();
              });
          } else {
            done();
          }
        }
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.common-seach-wrap {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
}

.common-level-rail {
  padding: 0 20px 20px;
}

.product-content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.export-progress-content {
  padding: 20px 0;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.progress-detail {
  margin-top: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}

.progress-detail p {
  margin: 5px 0;
  color: #606266;
  font-size: 14px;
}

.el-dropdown {
  margin-left: 10px;
}

.el-button + .el-dropdown {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/merchant_onboarding/index/index.vue